
<template>
  <div>
    <div class="os-url-main">
      <Divider>LightPicture</Divider>
      <div class="os-main">
        <div class="os-item">
          <span class="osuu-net geek-github"></span>
          <p>github</p>
        </div>
        <div class="os-item">
          <span class="osuu-net geek-gitee2"></span>
          <p>gitee</p>
        </div>
        
      </div>
      <!-- <p>作者：@王多余</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
   
  },
};
</script>

<style lang="less" scoped>
@import url("../assets/css/theme.min.css");
p{
  text-align: center;
}
</style>